import { Facebook, Instagram, Linkedin, Mail, MapPin, MessageCircle, Phone, Youtube } from "lucide-react";
import { UGI_CONTACT, UGI_SOCIAL_LINKS } from "@/config/contact";

function XIcon({ size = 16, strokeWidth = 1.7, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M4 4l16 16" />
      <path d="M20 4L4 20" />
    </svg>
  );
}

const socialIcons = { instagram: Instagram, facebook: Facebook, linkedin: Linkedin, x: XIcon, youtube: Youtube };

export default function ContactPanel() {
  return (
    <div data-testid="ugi-contact-panel">
      <h2 className="text-xs font-bold uppercase tracking-[0.24em] text-[#C5A059]">Contact</h2>
      <ul className="mt-5 grid gap-4 text-sm leading-7 text-[#D8D0C3]">
        <li className="flex gap-3">
          <MapPin size={17} strokeWidth={1.5} className="mt-1 shrink-0 text-[#C5A059]" />
          <span data-testid="contact-address">{UGI_CONTACT.address}</span>
        </li>
        <li className="flex gap-3">
          <Mail size={17} strokeWidth={1.5} className="mt-1 shrink-0 text-[#C5A059]" />
          <a data-testid="contact-email-link" href={`mailto:${UGI_CONTACT.email}`} className="transition-colors hover:text-[#FDFBF7] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059]">{UGI_CONTACT.email}</a>
        </li>
        <li className="flex gap-3">
          <Phone size={17} strokeWidth={1.5} className="mt-1 shrink-0 text-[#C5A059]" />
          <a data-testid="contact-phone-link" href={`tel:${UGI_CONTACT.phone.replaceAll(" ", "")}`} className="transition-colors hover:text-[#FDFBF7] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059]">{UGI_CONTACT.phone}</a>
        </li>
        <li className="flex gap-3">
          <MessageCircle size={17} strokeWidth={1.5} className="mt-1 shrink-0 text-[#C5A059]" />
          <span className="flex flex-col gap-1">
            {UGI_CONTACT.whatsapp.map((number, index) => (
              <a key={number} data-testid={`contact-whatsapp-link-${index + 1}`} href={`https://wa.me/${number.replaceAll(" ", "").replace("+", "")}`} target="_blank" rel="noreferrer" className="transition-colors hover:text-[#FDFBF7] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059]">
                WhatsApp: {number}
              </a>
            ))}
          </span>
        </li>
      </ul>

      <h3 className="mt-8 text-xs font-bold uppercase tracking-[0.24em] text-[#C5A059]">Social</h3>
      <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
        {UGI_SOCIAL_LINKS.map((link) => {
          const Icon = socialIcons[link.id];
          const configured = Boolean(link.href);
          return (
            <a key={link.id} data-testid={`social-link-${link.id}`} href={configured ? link.href : "#"} target={configured ? "_blank" : undefined} rel={configured ? "noreferrer" : undefined} aria-disabled={configured ? undefined : true} title={configured ? link.label : `${link.label} profile URL to be configured`} onClick={configured ? undefined : (event) => event.preventDefault()} className="inline-flex items-center gap-3 border border-[#FDFBF7]/10 px-3 py-2 text-xs font-semibold tracking-[0.08em] text-[#D8D0C3] transition-colors hover:border-[#C5A059]/50 hover:text-[#FDFBF7] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059]">
              <Icon size={16} strokeWidth={1.6} className="text-[#C5A059]" />
              {link.label}
            </a>
          );
        })}
      </div>
    </div>
  );
}
